import type BillDTO from "@tootsweet/model/datatransfer/BillDTO";
import React, { useMemo } from "react";
import { tt } from "../../../utils/i18n/i18n";
import KC_Span from "../../../designsystem/KC_Span/KC_Span";
import moment from "moment-timezone";

interface PropsI {
  isSubscription: boolean;
  bill: BillDTO;
}

export function FromTo(props: PropsI) {
  const startDate = useMemo(() => {
    if (!props.bill || !props.isSubscription) {
      return "";
    }
    return moment(props.bill.subscriptionPeriodStart).format(
      tt("date_format_full_date")
    );
  }, [props.bill]);

  const endDate = useMemo(() => {
    if (!props.bill || !props.isSubscription) {
      return "";
    }
    return moment(props.bill.subscriptionPeriodEnd).format(
      tt("date_format_full_date")
    );
  }, [props.bill]);

  return props.isSubscription ? (
    <KC_Span text={`${tt("from")} ${startDate} ${tt("to")} ${endDate}`} />
  ) : (
    <span>-</span>
  );
}
